import { Routes } from '@angular/router';

import { ERoutes } from '../../types/app-routes';
import {
  CATEGORY_AWARD,
  ECategoryAward,
} from '../../../schema/hasura/main/cls-category-award.schema';
import { CardCanDeactivateGuard } from '../../services/card-can-deactivate-guard.service';

export const awardCaseRoutes: Routes = [
  {
    path: ERoutes.AWARD_CASE,
    children: [
      {
        path: ECategoryAward.STATE,
        data: {
          categoryCode: ECategoryAward.STATE,
          categoryTitle: CATEGORY_AWARD.STATE,
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./award-case-table/award-case-table.component').then(
                (m) => m.AwardCaseTableComponent
              ),
          },
          {
            path: 'card',
            canDeactivate: [CardCanDeactivateGuard],
            loadComponent: () =>
              import('./award-case-card/award-case-card.component').then(
                (m) => m.AwardCaseCardComponent
              ),
          },
        ],
      },

      {
        path: ECategoryAward.REGIONAL,
        data: {
          categoryCode: ECategoryAward.REGIONAL,
          categoryTitle: CATEGORY_AWARD.REGIONAL,
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./award-case-table/award-case-table.component').then(
                (m) => m.AwardCaseTableComponent
              ),
          },
          {
            path: 'card',
            canDeactivate: [CardCanDeactivateGuard],
            loadComponent: () =>
              import('./award-case-card/award-case-card.component').then(
                (m) => m.AwardCaseCardComponent
              ),
          },
        ],
      },

      {
        path: ECategoryAward.ENCOURAGEMENT,
        data: {
          categoryCode: ECategoryAward.ENCOURAGEMENT,
          categoryTitle: CATEGORY_AWARD.ENCOURAGEMENT,
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./award-case-table/award-case-table.component').then(
                (m) => m.AwardCaseTableComponent
              ),
          },
          {
            path: 'card',
            canDeactivate: [CardCanDeactivateGuard],
            loadComponent: () =>
              import('./award-case-card/award-case-card.component').then(
                (m) => m.AwardCaseCardComponent
              ),
          },
        ],
      },
    ],
  },
];
